//notificationform.jsx
import React, { useEffect, useState } from "react";
import {
  Button,
  TextField,
  FormControlLabel,
  Radio,
  RadioGroup,
  FormLabel,
  FormControl
} from "@mui/material";
import ValueSelector from "./helper/ValueSelector";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { useGlobalConfig } from "context/GlobalContext";

const NotificationForm = ({
  pilotId,
  setPilotId,
  startTime,
  setStartTime,
  endTime,
  setEndTime,
  eventName,
  setEventName,
  notificationStatus,
  setNotificationStatus,
  onFetchNotifications,
  partnerUserId,
  setPartnerUserId,
  userId,
  setUserId,
}) => {
  const { rc } = useGlobalConfig();
  // const pilotOptions = ["10037", "10057", "10082"]; // Add more pilots as needed
  const eventOptions = ["MONTHLY_SUMMARY", "NEIGHBOURHOOD_COMPARISON","EV_WELCOME"]; // Add more events as needed
  const notificationStatuses = ["SCHEDULED", "REVOKED", "GENERATED"]; // Add more statuses as needed
  const today = Math.floor(Date.now()); // Current time in seconds
  const [endpointUrl, setEndpointUrl] = useState("");
  const [accessToken, setAccessToken] = useState("");
  const [idType, setIdType] = useState('pilotId'); // Set default to pilotId

  const isValidUrl = (url) => {
    try {
      new URL(url); // This will throw an error if the URL is invalid
      return true;
    } catch (error) {
      return false;
    }
  };
  
  // Load values from local storage on component mount
  useEffect(() => {
    const storedUrl = localStorage.getItem("endpointUrl");
    const storedToken = localStorage.getItem("accessToken");
    // if (storedUrl) setEndpointUrl(storedUrl); rc.apiClient.setApiEndpoint(storedUrl);
    // if (storedToken) setAccessToken(storedToken); rc.session.setAccessToken(storedToken);

    console.log("Stored URL:", storedUrl); // Debugging log
    console.log("Stored Token:", storedToken); // Debugging log

    if (storedUrl && isValidUrl(storedUrl)) {
      setEndpointUrl(storedUrl);
      rc.apiClient.setApiEndpoint(storedUrl);
    } else {
      console.error("Invalid URL stored in localStorage:", storedUrl);
    }
  
    if (storedToken) {
      setAccessToken(storedToken);
      rc.session.setAccessToken(storedToken);
    }
  }, []);

  useEffect(() => {
    // Clear other identifier fields when idType changes
    if (idType === 'partnerUserId') {
      setUserId('');
    } else if (idType === 'userId') {
      setPartnerUserId('');
    }
  }, [idType]);

  // Update local storage whenever endpointUrl or accessToken changes
  useEffect(() => {
    localStorage.setItem("endpointUrl", endpointUrl);
    rc.apiClient.setApiEndpoint(endpointUrl);
    localStorage.setItem("accessToken", accessToken);
    rc.session.setAccessToken(accessToken);
  }, [endpointUrl, accessToken]);

  const handleReset = () => {
    setPilotId("");
    setStartTime(null);
    setEndTime(null);
    setEventName("");
    setNotificationStatus("");
    setEndpointUrl("");
    setAccessToken("");
    localStorage.removeItem("endpointUrl");
    localStorage.removeItem("accessToken");
    window.location.reload(); // Optional: Reload the page
  };

  return (
    <div>
      <TextField
        label="Endpoint URL"
        value={endpointUrl}
        onChange={(e) => { setEndpointUrl(e.target.value);}}
        variant="outlined"
        margin="normal"
        required
        style={{ width: "300px", marginRight: "8px" }}
      />

      <TextField
        label="Access Token"
        value={accessToken}
        onChange={(e) => setAccessToken(e.target.value)}
        variant="outlined"
        margin="normal"
        required
        style={{ width: "300px" }}
      />
<br />
      <TextField
        label="Pilot ID"
        value={pilotId}
        onChange={(e) => setPilotId(e.target.value)}
        variant="outlined"
        margin="normal"
        required
        style={{ width: "300px" }}
      />
<br />
      <FormControl component="fieldset" style={{ marginTop: 16 }}>
        <FormLabel component="legend">Select Identifier Type</FormLabel>
        <RadioGroup
          row
          value={idType}
          onChange={(e) => setIdType(e.target.value)}
        >
          <FormControlLabel
            value="userId"
            control={<Radio />}
            label="User ID"
          />
          <FormControlLabel
            value="partnerUserId"
            control={<Radio />}
            label="Partner User ID"
          />
          
        </RadioGroup>
      </FormControl>
      <br />
      
      {idType === 'userId' && (
        <TextField
          label="User ID"
          value={userId}
          onChange={(e) => setUserId(e.target.value)}
          variant="outlined"
          margin="normal"
          style={{ width: "300px" }}
        />
      )}
      {idType === 'partnerUserId' && (
        <TextField
          label="Partner User ID"
          value={partnerUserId}
          onChange={(e) => setPartnerUserId(e.target.value)}
          variant="outlined"
          margin="normal"
          style={{ width: "300px" }}
        />
      )}
      <br />
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DateTimePicker
          label="Start Time"
          value={startTime}
          onChange={(newValue) => {
            setStartTime(newValue ? Math.floor(newValue.getTime()) : null);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              required
              variant="outlined"
              margin="normal"
              style={{ marginRight: "8px", width: "300px" }}
            />
          )}
          maxDateTime={new Date(today)} // Set max date to today
          inputFormat="dd/MM/yyyy HH:mm"
        />

        <DateTimePicker
          label="End Time"
          value={endTime}
          onChange={(newValue) => {
            setEndTime(newValue ? Math.floor(newValue.getTime()) : null);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              required
              variant="outlined"
              margin="normal"
              style={{ width: "300px" }}
            />
          )}
          maxDateTime={new Date(today)} // Set max date to today
          inputFormat="dd/MM/yyyy HH:mm"
        />
      </LocalizationProvider>

      <ValueSelector
        options={eventOptions}
        fieldName="Select Event*"
        fieldValue={eventName}
        onValue
        onValueChange={setEventName}
        mandatory={true}
      />

      <ValueSelector
        options={notificationStatuses}
        fieldName="Select Notification Status*"
        fieldValue={notificationStatus}
        onValueChange={setNotificationStatus}
        mandatory={true}
      />

      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          if (pilotId.trim() === "") {
            console.error("Error: Pilot ID is required");
            alert("Error: Pilot ID is required");
          } else {
            onFetchNotifications();
          }
        }}
        style={{ margin: "16px 5px" }}
      >
        Fetch Notifications
      </Button>

      <Button
        variant="contained"
        color="secondary"
        onClick={handleReset} // Call the reset function
        style={{ margin: "16px 5px" }}
      >
        Reset Form
      </Button>
    </div>
  );
};

export default NotificationForm;